import AudioListen from "@/components/AudioListen";
import { CURRICULUM } from "@/lib/curriculum";

export const OneClickReview = ({ available }) => (
  <div className="tacc-card p-6 md:p-8 border-[#F59E0B]/30" data-testid="one-click-review">
    <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
      <div className="section-tag">§ One-Click Review · Everything members get, on one screen</div>
      <div className="flex items-center gap-3" data-testid="review-avatar">
        <img src="/author/avatar.jpg" alt="The Healer avatar" className="w-12 h-12 rounded-full object-cover border-2 border-[#F59E0B]/70" />
        <div>
          <div className="font-mono text-[9px] tracking-[0.25em] uppercase text-[#B45309]">The Healer Avatar</div>
          <div className="text-xs text-[#78716C]">Appears whenever your voice narrates</div>
        </div>
      </div>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {CURRICULUM.map((m) => {
        const hasVid = available.has(m.id);
        return (
          <div key={m.id} className="border border-[#E7DFD5] p-5" data-testid={`review-module-${m.id}`}>
            <div className="flex items-center gap-3 mb-2">
              <span className="font-display text-2xl text-[#B45309] leading-none">{m.n}</span>
              <h4 className="font-heading text-base tracking-tight flex-1">{m.title}</h4>
              <span className={`font-mono text-[9px] tracking-[0.2em] uppercase px-1.5 py-0.5 border ${hasVid ? "text-emerald-400 border-emerald-400/30" : "text-[#78716C] border-[#E7DFD5]"}`}>
                {hasVid ? "✓ Video" : "Audio only"}
              </span>
            </div>
            <div className="font-mono text-[9px] tracking-[0.25em] uppercase text-[#78716C] mb-3">{m.focus} · {m.duration}</div>
            <p className="text-[#44403C] text-sm leading-relaxed mb-3">{m.narration}</p>
            <div className="border-l-2 border-[#F59E0B]/50 pl-3 mb-4">
              <div className="font-mono text-[9px] tracking-[0.25em] uppercase text-[#B45309] mb-1">Work it — member question</div>
              <p className="text-[#78716C] text-sm leading-relaxed">{m.workIt}</p>
            </div>
            <AudioListen text={m.narration} label="Hear it" testid={`review-listen-${m.id}`} />
          </div>
        );
      })}
    </div>
  </div>
);
